import PostPage from './postPage';

function PostPageRoute() {
  return <PostPage />;
}

export default PostPageRoute;
